<template>
    <div class="crm-main-cont">
        <a-tabs defaultActiveKey="1" @change="callback">
            <a-tab-pane tab="部门" key="1">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div>
                        <a-row class="marRight">
                            <a-col :span="2">总数据项：</a-col>
                            <a-col :span="2">{{ sumSjx }}</a-col>
                            <a-col :span="3">归集数据总量：</a-col>
                            <a-col :span="2">{{ sumSjl }}</a-col>
                            <a-col :span="4">数据归集覆盖率：</a-col>
                            <a-col :span="2">{{( sumFgl*100).toFixed(2) }}&nbsp;&nbsp;&nbsp;%</a-col>
                        </a-row>
                        <br />
                    </div>
                    <a-table
                            :columns="columns"
                            :dataSource="data"
                            class="components-table-demo-nested"
                            @expand="expandedRowsChange"
                            @change="change" :pagination="pagination"
                    >
                        <template slot="expandedRowRender" slot-scope="record">
                            <a-spin tip="Loading..." :spinning="spinning_inner" style="margin-top:-35px;">
                            <a-table
                                    rowKey="rowKey"
                                    :columns="innerColumns"
                                    :dataSource="innerData[record.key]"
                                    :pagination="false"
                            >
                                <template slot="infochange" slot-scope="text, record">
                                    <span v-if="text === '0'">实时</span>
                                    <span v-if="text === '1'">每日</span>
                                    <span v-if="text === '2'">每周</span>
                                    <span v-if="text === '3'">每月</span>
                                    <span v-if="text === '4'">每季</span>
                                    <span v-if="text === '5'">每半年</span>
                                    <span v-if="text === '6'">每年</span>
                                    <span v-if="text === '7'">定期</span>
                                </template>
                            </a-table>
                            </a-spin>
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>

<!--            <a-tab-pane tab="主体" key="2">
                <a-spin tip="Loading..." :spinning="spinning">
                    <div>
                        <a-row class="marRight">
                            <a-col :span="2">总数据项：</a-col>
                            <a-col :span="2">{{ sumSjx }}</a-col>
                            <a-col :span="3">归集数据总量：</a-col>
                            <a-col :span="2">{{ sumSjl }}</a-col>
                            <a-col :span="4">数据归集覆盖率：</a-col>
                            <a-col :span="2">{{( sumFgl*100).toFixed(2) }}&nbsp;&nbsp;&nbsp;%</a-col>
                        </a-row>
                        <br />
                    </div>
                    <a-table
                            :columns="columnsData"
                            :dataSource="dataSourceData"
                            class="components-table-demo-nested"
                            @expand="expandedRowsChange2"
                            :pagination="false"
                    >
                        <template slot="zttype" slot-scope="text, record">
                            <span v-if="text === '0'">企业法人</span>
                            <span v-if="text === '1'">自然人</span>
                            <span v-if="text === '2'">事业单位</span>
                            <span v-if="text === '3'">社会组织</span>
                            <span v-if="text === '4'">政府机构</span>
                        </template>
                        <template slot="expandedRowRender" slot-scope="record">
                            <a-spin tip="Loading..." :spinning="spinning_inner" style="margin-top:-35px;">
                                <a-table
                                        rowKey="rowKey"
                                        :columns="innerColumnsData[record.key]"
                                        :dataSource="innerData2[record.key]"
                                        :pagination="false"
                                >
                                    <template slot="infochange" slot-scope="text, record">
                                        <span v-if="text === '0'">实时</span>
                                        <span v-if="text === '1'">每日</span>
                                        <span v-if="text === '2'">每周</span>
                                        <span v-if="text === '3'">每月</span>
                                        <span v-if="text === '4'">每季</span>
                                        <span v-if="text === '5'">每半年</span>
                                        <span v-if="text === '6'">每年</span>
                                        <span v-if="text === '7'">定期</span>
                                    </template>
                                </a-table>
                            </a-spin>
                        </template>
                    </a-table>
                </a-spin>
            </a-tab-pane>-->
        </a-tabs>
    </div>
</template>


<script >
    import {applyList, childdataList, childList, dataList} from "../../api/operate/creditData";

    const columns = [
        { title: "部门", dataIndex: "dept", key: "dept" },
        { title: "信用目录个数", dataIndex: "dirnum", key: "dirnum" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "数据量总数", dataIndex: "zs", key: "zs" },
        /*{ title: "企业数据量", dataIndex: "qydataitem", key: "qydataitem" },
        { title: "自然人数据量", dataIndex: "zrrdataitem", key: "zrrdataitem" },
        { title: "社会组织数据量", dataIndex: "shzzdataitem", key: "shzzdataitem" },
        { title: "事业单位数据量", dataIndex: "sydwdataitem", key: "sydwdataitem" },
        { title: "政府机构数据量", dataIndex: "zfjgdataitem", key: "zfjgdataitem" }*/
    ];

    const innerColumns = [
        { title: "目录名称", dataIndex: "directoryname", key: "directoryname" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "数据量", dataIndex: "qydataitem",key: "qydataitem"},
        /*{ title: "自然人数据量", dataIndex: "zrrdataitem", key: "zrrdataitem" },
        { title: "社会组织数据量", dataIndex: "shzzdataitem", key: "shzzdataitem" },
        { title: "事业单位数据量", dataIndex: "sydwdataitem", key: "sydwdataitem" },
        { title: "政府机构数据量", dataIndex: "zfjgdataitem", key: "zfjgdataitem" },*/
        { title: "更新频率", dataIndex: "infochange", key: "infochange" ,scopedSlots: { customRender: "infochange" } },
        { title: "最后更新时间", dataIndex: "updatetime", key: "updatetime" }
    ];

    const columnsData= [
        { title: "主体类别", dataIndex: "zttype", key: "zttype",scopedSlots: { customRender: "zttype" } },
        { title: "信用目录个数", dataIndex: "dirnum", key: "dirnum" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "数据量", dataIndex: "ztdataitem", key: "ztdataitem" },
    ];

    const columns1 = [
        { title: "目录名称", dataIndex: "directoryname", key: "directoryname" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "企业数据量", dataIndex: "qydataitem",key: "qydataitem"},
        { title: "更新频率", dataIndex: "infochange", key: "infochange" ,scopedSlots: { customRender: "infochange" }  },
        { title: "最后更新时间", dataIndex: "updatetime", key: "updatetime" }
    ]
    const columns2 = [
        { title: "目录名称", dataIndex: "directoryname", key: "directoryname" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "自然人数据量", dataIndex: "zrrdataitem", key: "zrrdataitem" },
        { title: "更新频率", dataIndex: "infochange", key: "infochange" ,scopedSlots: { customRender: "infochange" }  },
        { title: "最后更新时间", dataIndex: "updatetime", key: "updatetime" }
    ]
    const columns3 = [
        { title: "目录名称", dataIndex: "directoryname", key: "directoryname" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "事业单位数据量", dataIndex: "sydwdataitem", key: "sydwdataitem" },
        { title: "更新频率", dataIndex: "infochange", key: "infochange" ,scopedSlots: { customRender: "infochange" }  },
        { title: "最后更新时间", dataIndex: "updatetime", key: "updatetime" }
    ]
    const columns4 = [
        { title: "目录名称", dataIndex: "directoryname", key: "directoryname" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "社会组织数据量", dataIndex: "shzzdataitem", key: "shzzdataitem" },
        { title: "更新频率", dataIndex: "infochange", key: "infochange" ,scopedSlots: { customRender: "infochange" }  },
        { title: "最后更新时间", dataIndex: "updatetime", key: "updatetime" }
    ]
    const columns5 = [
        { title: "目录名称", dataIndex: "directoryname", key: "directoryname" },
        { title: "数据项个数", dataIndex: "dataitem", key: "dataitem" },
        { title: "政府机构数据量", dataIndex: "zfjgdataitem", key: "zfjgdataitem" },
        { title: "更新频率", dataIndex: "infochange", key: "infochange" ,scopedSlots: { customRender: "infochange" }  },
        { title: "最后更新时间", dataIndex: "updatetime", key: "updatetime" }
    ]

    export default {
        data() {
            return {
                spinning: false,
                spinning_inner: false,
                data:[],
                innerData:[],
                columns,
                innerColumns,
                columnsData,
                innerColumnsData:[
                    columns1,
                    columns2,
                    columns3,
                    columns4,
                    columns5,
                ],
                dataSourceData: [],
                innerData2:[],
                sumSjx:"",
                sumSjl:"",
                sumFgl:"",
                shstate: "1",
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                }
            };
        },
        //列表显示
        beforeRouteEnter(to,from,next){
            applyList(1,1).then(res => {
                console.log(res);
                next(vm =>{
                    if(res.data.success === "TRUE"){
                        res.data.data.page.list.map((item,index) =>{
                            Object.assign(item,{
                                key:index
                            })
                        })
                        vm.data = res.data.data.page.list;
                        vm.sumSjx = res.data.data.sjx;
                        vm.sumSjl = res.data.data.sjl;
                        vm.sumFgl = res.data.data.fgl;
                        vm.pagination = {
                            current : res.data.data.page.pageNum,
                            pageSize: res.data.data.page.pageSize,
                            total: res.data.data.page.total
                        } ;
                    }
                })
            }).catch(error =>{
                next(vm=>{
                    vm.$message.error("服务器出错！请稍后再试!");
                    vm.$Progress.fail();
                });
            })
        },
        methods: {
            //父级列表下拉
            expandedRowsChange(expandedRows,record){
                this.spinning_inner = true;
                console.log(expandedRows)
                console.log(record.key)
                childList(record.deptid).then(res => {
                    res.data.data.page.map((item,index) =>{
                        Object.assign(item,{
                            rowKey:index
                        })
                    })
                    this.spinning_inner = false;
                    this.$set(this.innerData,record.key,res.data.data.page);

                    /* console.log();*/
                    /*if (res.data.success === "TRUE") {
                        this.innerData= res.data.data.page.list;
                    }*/
                });

            },
            //数据父级列表下拉
            expandedRowsChange2(expandedRows,record){
                this.spinning_inner = true;
                console.log(expandedRows)
                console.log(record.key)
                childdataList(record.key).then(res => {
                    res.data.data.page.map((item,index) =>{
                        Object.assign(item,{
                            rowKey:index
                        })
                    })
                    this.spinning_inner = false;
                    this.$set(this.innerData2,record.key,res.data.data.page);
                });

            },
            //切换tab 赋�?�状�?
            callback(key) {
                console.log(key);
                this.shstate = key;
                this.initList();
            },
            //分页切换
            change(page) {
                this.pagination.current = page.current;
                this.initList();
                this.spinning = false;
            },
            initList() {
                this.spinning = true;
                if (this.shstate === "1") {
                    applyList(this.pagination.current,1).then(res => {
                        if (res.data.success === "TRUE") {
                            this.spinning = false;
                            this.data = res.data.data.page.list;
                            this.pagination = {
                                current: res.data.data.page.pageNum,
                                pageSize: res.data.data.page.pageSize,
                                total: res.data.data.page.total
                            };
                        }
                    });
                } else if (this.shstate === "2") {
                    dataList(2).then(res => {
                        if (res.data.success === "TRUE") {
                            console.log(res.data.data);
                            this.spinning = false;
                            this.dataSourceData = res.data.data.page;
                            /*this.sumdataSourceData = res.data.data.sum;*/
                        }
                    });
                }
            }
        }
    };
    </script >
    <style scoped lang="less">
    .ant-btn {
        font-size: 12px;
    }
    .ant-table-wrapper {
        font-size: 12px;
        margin-top: 20px;
    }
    .ant-table-row > td {
        font-size: 12px;
    }
    .spin-content {
        border: 1px solid #91d5ff;
        background-color: #e6f7ff;
        padding: 30px;
    }
    .marRight {
        margin-left: 15px;
        margin-bottom: -20px;
    }
    .ant-col-2 {
        display: block;
        box-sizing: border-box;
        width: 7%;
    }
    .ant-col-3 {
        display: block;
        box-sizing: border-box;
        width: 10%;
    }
    .ant-col-4 {
        display: block;
        box-sizing: border-box;
        width: 11%;
    }

    </style>